import React from 'react';
import styled from '@cthings.co/styled-components';
import { CommonButton } from '@cthings.co/buttons';
import { media } from '@cthings.co/styles-utils';
import { Text, TextType } from '@bit/first-scope.text';
import { CustomModal } from '../../../../components/customModal/CustomModal';
import { useTheme } from '@cthings.co/styled-components';

const StyledCustomModal = styled(CustomModal)`
  & > div {
    max-width: 385px;

    ${media.semiTablet} {
      max-width: 100%;
    }
  }
`;

const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const ButtonRow = styled.div`
  display: flex;
  justify-content: flex-end;

  ${media.semiTablet} {
    width: 100%;
    margin-bottom: 10px;
    flex-direction: column-reverse;
  }
`;

const StyledCancelButton = styled(CommonButton)`
  margin: 0 16px 0 0;

  ${media.semiTablet} {
    width: 100%;
    margin: 0;
  }
`;

const StyledNextButton = styled(CommonButton)`
  ${media.semiTablet} {
    width: 100%;
    margin-bottom: 10px;
  }
`;

export const SaveAsMainLocation = ({
  isOpenModal,
  language,
  onCancel,
  onSave,
}: {
  isOpenModal: boolean;
  language?: any;
  onCancel: () => void;
  onSave: () => void;
}) => {
  const theme = useTheme();
  const { black1, gray1, pureWhite } = theme.colors;

  return (
    <StyledCustomModal isOpen={isOpenModal}>
      <TitleWrapper>
        <Text type={TextType.TEXT_14_BLACK} fontSize={'18px'} weight={'600'} color={black1}>
          {language.gpsDetailsSaveAsMainLocTitle}
        </Text>
      </TitleWrapper>

      <Text type={TextType.TEXT_14_BLACK} weight={'400'} color={gray1} margin={'15px 0 24px 0'}>
        {language.gpsDetailsSaveAsMainLocText}
      </Text>

      <ButtonRow>
        <StyledCancelButton
          onClick={onCancel}
          width={'116px'}
          colors={{
            main: black1,
            background: pureWhite,
          }}
        >
          {language.cancelButton}
        </StyledCancelButton>
        <StyledNextButton onClick={onSave} width={'116px'}>
          {language.saveButton}
        </StyledNextButton>
      </ButtonRow>
    </StyledCustomModal>
  );
};
